<template>
    <div class="cerMoreInfo">
      <i class="iconfont iconfanhui back" @click.stop="$router.push({path: '/results'})">返回</i>
      <div class="list_wrap">
        <div class="list_box">
          <p class="title">血浆神经酰胺是由不稳定的动脉粥样硬化斑块 引起的不良心血管事件的预测因子。</p>
          <img src="../../assets/images/ceramide/moreInfo1.png" alt="图1">
          <p class="word">
            神经酰胺是复杂的脂质，在细胞膜完整性、细胞应激反应、炎症信号传导和细胞凋亡中起着核心作用。 由饱和脂肪和鞘氨醇合成的神经酰胺发生在所有组织中。 在代谢功能障碍和血脂异常的情况下，神经酰胺会堆积在不适合脂质存储的组织中。 三种特定的神经酰胺已被确定与心血管疾病高度相关：Cer（16：0），Cer（18：0），Cer（24：0），Cer（24：1）。神经酰胺与胆固醇有许多相似之处。二者均有粘稠、多脂的特性，是构成基本细胞生存所必需的环境，在细胞膜中起着重要的骨架作用。神经酰胺和胆固醇都是复杂生物合成途径中的中间体，形成并积聚大量复杂脂类。
          </p>
        </div>
        <div class="list_box">
          <img class="img2" src="../../assets/images/ceramide/moreInfo2.png" alt="图2">
          <p class="word">
            同胆固醇一样，神经酰胺在动脉粥样硬化病变中积聚，在斑块中大量存在。患有冠状动脉疾病（CAD），胰岛素抵抗和2型糖尿病的患者血浆神经酰胺水平升高。 与稳定的CAD相比，患有急性冠状动脉综合征和不稳定型心绞痛的患者血浆神经酰胺水平明显升高。血浆神经酰胺是急性冠状动脉综合征和不稳定动脉粥样硬化性心血管疾病的新型生物标志物。 另外，由于血浆神经酰胺现在可以通过质谱量化，神经酰胺与心血管死亡之间的关系可在稳定和不稳定的冠状动脉疾病(CAD)患者群体中检测。也可对原发性和继发性心肌梗死(MI)进行风险评估。
          </p>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'cerMoreInfo'
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/functions";
  .cerMoreInfo {
    width: 100%;
    height: 100%;
    background: #C4E3FE;
    position: relative;
    overflow: auto;

    .back {
      position: absolute;
      top: pxToRem(20px);
      left: pxToRem(20px);
      font-size: pxToRem(25px);
      color: #000;
    }

    .list_wrap {
      clear: both;
      width: 100%;
      padding: 0 pxToRem(36px);
      margin: pxToRem(92px) auto;

      .list_box {
        padding: pxToRem(76px);
        background: #fff;
        border-radius: pxToRem(20px);
        margin-bottom: pxToRem(40px);

        p {
          text-indent: 1em;
        }

        img {
          width: 100%;
          height: pxToRem(286px);
        }
        .img2 {
          height: pxToRem(414px);
        }

        .title {
          font-size: pxToRem(24px);
          color: #000;
          letter-spacing: 1px;
          margin-bottom: pxToRem(44px);
        }

        .word {
          font-size: pxToRem(22px);
          font-weight: 300;
          color: #221815;
          letter-spacing: 1px;
          margin-top: pxToRem(40px);
          text-align: justify;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/ceramide/cerMoreInfo.vue